<template>
    <el-dialog title="详情" :visible.sync="visible" width="50%" :before-close="handleClose">
        <el-descriptions :column="columns" :labelStyle="labelStyle" :contentStyle="{ flex: 1 }">
            <el-descriptions-item v-for="(item, index) in detailCols" :span="item.span ? item.span : 1" :key="index"
                :label="item.label">{{ item.formatter ? item.formatter(record) : record[item.prop]
                }}</el-descriptions-item>
        </el-descriptions>
        <!-- 是否需要table列表展示 -->
        <div v-if="hasTable">
            <div class="table-title">{{ tableTitle }}</div>
            <el-table border :data="tableData" stripe style="width: 100%">
                <el-table-column v-for="column in tableCols" :key="column.prop" :prop="column.prop"
                    :label="column.label" :formatter="column.formatter" align="center">
                </el-table-column>
            </el-table>
        </div>
    </el-dialog>
</template>
<script>
export default {
    name: 'comDetail',
    props: ['detail', 'detailCols', 'onCancel'],
    data() {
        return {
            visible: this.detail.visible,
            record: this.detail.record,
            detailCols: this.detailCols,
            columns: this.detail.columns,
            labelStyle: this.detail.labelStyle,
            hasTable: this.detail.hasTable,
            tableCols: this.detail.tableCols,
            tableData: this.detail.tableData,
            tableTitle: this.detail.tableTitle
        }
    },
    watch: {
        detail: {
            handler(newVal) {
                this.visible = newVal.visible
                this.record = newVal.record
                this.columns = newVal.columns || 3
                this.labelStyle = newVal.labelStyle || { width: '80px', textAlign: 'right' }
                this.hasTable = newVal.hasTable || false
                this.tableCols = newVal.tableCols || []
                this.tableData = newVal.tableData || []
                this.tableTitle = newVal.tableTitle || '详细信息'
            },
            deep: true
        },
        detailCols: {
            handler(newVal) {
                this.detailCols = newVal
            },
            deep: true
        }
    },
    methods: {
        handleClose() {
            this.onCancel()
        }
    }
}
</script>
<style scoped>
.table-title {
    margin: 16px 0;
    font-weight: 600;
    font-size: 18px;

    &::before {
        background: #4a62e7;
        content: "";
        display: inline-block;
        height: 18px;
        margin-right: 6px;
        position: relative;
        top: 2px;
        width: 4px;
    }
}
</style>